module.exports = "/images/vendor/flag-icon-css/flags/1x1/ag.svg?53a600867bab3b2284da8445e7d9cc93";